var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCardDegree(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 151,
    height: 105,
    viewBox: "0 0 151 105",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M106.082 47.2582L66.3035 60.2681C63.177 61.2915 59.74 60.6907 57.1482 58.6642L24.1678 32.899C21.4946 30.8113 22.238 26.5901 25.4561 25.5361L65.2342 12.5262C68.3606 11.5027 71.7977 12.1036 74.3894 14.1302L107.37 39.8953C110.043 41.983 109.3 46.2042 106.082 47.2582Z",
    fill: "#7A5FFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M90.6427 63.4252C87.7505 79.2 30.2678 69.1842 33.1753 53.3483L36.984 31.6058C39.6165 16.5948 97.0839 26.6717 94.4514 41.6827L90.6427 63.4252Z",
    fill: "#5F4BEF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M86.3176 62.0678C87.2244 56.8935 77.1339 50.8018 63.7799 48.4615C50.4258 46.1212 38.8651 48.4186 37.9583 53.593C37.0515 58.7673 47.1421 64.8591 60.4961 67.1993C73.8502 69.5396 85.4109 67.2421 86.3176 62.0678Z",
    fill: "#4D38D9"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M85.276 45.8885L83.117 43.7091L80.3419 45.0229C78.8347 45.7358 77.1493 44.4526 77.4344 42.8079L81.4876 19.6753L91.758 27.7053L88.7639 44.7937C88.4737 46.4384 86.4522 47.0698 85.276 45.8885Z",
    fill: "#FFB95C"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardDegree);
export default __webpack_public_path__ + "static/media/card_degree.4bb8a1848b419012573fc2925bb5716f.svg";
export { ForwardRef as ReactComponent };